module.exports = __webpack_public_path__ + "catalog/items/bathroom/Sink/Sink.svg";